export default {"src":"/_next/static/media/vat.07400cfe.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};